import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { ROLES } from '../utils/roles';
import { recordHeartbeat } from '../services/studyTimeService';

const HEARTBEAT_INTERVAL = 60_000;
const ACTIVITY_WINDOW = 60_000;

export function useStudyTimeTracker() {
  const { user, role } = useAuth();
  const { pathname } = useLocation();
  const lastActivity = useRef(Date.now());
  const sentInitial = useRef(false);

  useEffect(() => {
    if (!user || role !== ROLES.STUDENT || pathname.startsWith('/demo')) return;

    const markActive = () => { lastActivity.current = Date.now(); };

    if (!sentInitial.current) {
      sentInitial.current = true;
      recordHeartbeat(user.uid).catch((err) => {
        console.warn('[StudyTime] initial heartbeat failed:', err?.code || err?.message || err);
      });
    }

    const events = ['click', 'touchstart', 'scroll', 'keydown'];
    events.forEach((e) => window.addEventListener(e, markActive, { passive: true }));

    const timer = setInterval(() => {
      if (document.hidden) return;
      if (Date.now() - lastActivity.current > ACTIVITY_WINDOW) return;
      recordHeartbeat(user.uid).catch((err) => {
        console.warn('[StudyTime] heartbeat failed:', err?.code || err?.message || err);
      });
    }, HEARTBEAT_INTERVAL);

    return () => {
      events.forEach((e) => window.removeEventListener(e, markActive));
      clearInterval(timer);
    };
  }, [user, role, pathname]);
}
